// base rc-switch 1.8.0
import Switch from './Switch';

export default Switch;
